import IContact from '../interfaces/IContact';
import { Card, CardContent, CardMedia, CardProps, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import langContact from '../langs/langContact';
import Link from '@mui/material/Link';

type CContactCardProps = Omit<CardProps, 'children' | 'classes' | 'elevation' | 'raised' | 'variant'> & IContact;

const CContactCard = ({ firstName, lastName, img, position, email, sx, ...rest }: CContactCardProps) => {
	const { t } = useTranslation();
	const theme = useTheme();

	const name = `${firstName} ${lastName.toLocaleUpperCase()}`;
	return (
		<Card sx={{ boxShadow: 'none', ...sx }} {...rest}>
			<CardMedia
				component="img"
				height="320"
				image={img}
				alt={name}
				sx={{ objectPosition: '0 0', filter: 'grayscale(1)', paddingBottom: '0px' }}
			/>
			<CardContent
				sx={{
					backgroundColor: theme.palette.mode === 'dark' ? '#183B52' : '#FFFFFF',
				}}
			>
				<Typography
					sx={{
						color: theme.palette.mode === 'dark' ? '#2ABDBB' : '#1A2B48',
						fontWeight: 600,
						fontSize: '1.2rem',
						lineHeight: '1.5',
					}}
				>
					{name}
				</Typography>
				<Typography sx={{ color: '#6F8098', fontWeight: 600, fontSize: '0.95rem', lineHeight: '1.31' }}>
					{t(langContact[position].tag)}
				</Typography>
				<Typography
					noWrap
					sx={{
						color: theme.palette.mode === 'dark' ? '#D1D4DA' : '#1A2B48',
						fontWeight: 400,
						fontSize: '0.95rem',
						lineHeight: '1.5',
						cursor: 'pointer',
					}}
				>
					<Link data-testid="contact-email" href={`mailto:${email}`} underline="none">
						{email}
					</Link>
				</Typography>
			</CardContent>
		</Card>
	);
};

export default CContactCard;
